import type { DateString } from "@/types/common"
import type { PatientWeight } from "@/types/patient"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface PatientWeightPayload {
	/** in kg */
	weight: number
	date: DateString
	pregnancy_id?: number
	notes?: string
}

export default {
	list(patientId: number) {
		return HttpClient.get<PatientWeight[]>(`${API_ROOT}/patients/${patientId}/weights`)
	},
	create(patientId: number, payload: PatientWeightPayload) {
		return HttpClient.post<PatientWeight>(`${API_ROOT}/patients/${patientId}/weights`, payload)
	},
	update(patientId: number, weightId: number, payload: PatientWeightPayload) {
		return HttpClient.put<PatientWeight>(`${API_ROOT}/patients/${patientId}/weights/${weightId}`, payload)
	},
	delete(patientId: number, weightId: number) {
		return HttpClient.delete(`${API_ROOT}/patients/${patientId}/weights/${weightId}`)
	}
}
